import React, { useEffect, useState } from "react";
import "./FederalAndStates.css";
import { useNavigate } from "react-router-dom";
import api from "../../../services/baseUrl";
import { CircularProgress } from "@mui/material";
import SearchBox from "../Searchbox/Search";
import { stateImages } from "../CoatOfArms";
import Cookies from "js-cookie";

export default function FederalAndStates() {
  const navigate = useNavigate();
  const [libraries, setLibraries] = useState([]);
  const handleNavigation = (libraryId) => {
    navigate("/e-gazette/search", { state: { libraryId } });
  };
  // const cookie = Cookies.get("user") || sessionStorage.getItem("user");
  const cookie = sessionStorage.getItem("user");
  const packageCode = JSON.parse(cookie).packageModel.packageCode;

  const renderFederal = () => {
    const federalLibraries = libraries.find((library) => library.id === 14);

    if (!federalLibraries || !federalLibraries.library) {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <CircularProgress />
        </div>
      );
    }

    const filteredLibraries = federalLibraries.library.filter(
      (federalLibrary) => federalLibrary.orderId !== null
    );

    // Split the libraries into two columns
    const numRows = Math.ceil(filteredLibraries.length / 2);
    const column1 = filteredLibraries.slice(0, numRows);
    const column2 = filteredLibraries.slice(numRows);

    return (
      <tr>
        <td width={"10%"} className="logo-container">
          <img src={stateImages[0]} alt="jata negara" width={"100%"} />
        </td>
        <td colSpan={3} className="federal-and-states-table-content">
          <div className="federal-and-states-table-title">FEDERAL GAZETTE</div>
          <div className="federal-and-stated-table-line"></div>
          <div
            className="federal-and-states-list federal"
            style={{ display: "flex" }}
          >
            <div className="column" style={{ width: "58%" }}>
              {column1.map((federalLibrary) => (
                <div
                  key={federalLibrary.libraryId}
                  className="federal-and-states-list-item"
                  onClick={() => handleNavigation(federalLibrary.libraryId)}
                >
                  {replaceSpacesWithNbsp(federalLibrary.displayName) ||
                    "Unnamed Library"}
                </div>
              ))}
            </div>
            <div className="column">
              {column2.map((federalLibrary) => (
                <div
                  key={federalLibrary.libraryId}
                  className="federal-and-states-list-item"
                  onClick={() => handleNavigation(federalLibrary.libraryId)}
                >
                  {replaceSpacesWithNbsp(federalLibrary.displayName) ||
                    "Unnamed Library"}
                </div>
              ))}
            </div>
          </div>
        </td>
      </tr>
    );
  };

  const renderStates = () => {
    const stateLibraries = libraries.filter(
      (library) => library.id !== 14 && library.id !== 0
    );

    // Split stateLibraries into pairs of two items
    const statePairs = [];
    for (let i = 0; i < stateLibraries.length; i += 2) {
      statePairs.push(stateLibraries.slice(i, i + 2));
    }

    return (
      <>
        {statePairs.map((statePair, index) => (
          <tr key={index}>
            {statePair.map((stateLibrary, i) => (
              <>
                <td
                  key={stateLibrary.id}
                  width={"100px"}
                  className="logo-container"
                >
                  <img
                    src={stateImages[stateLibrary.orderId]}
                    alt={`jata-${stateLibrary.name.toLowerCase()}`}
                    style={{
                      width: "13vh",
                      objectFit: "contain",
                      height: "100px",
                    }}
                  />
                </td>
                <td
                  key={stateLibrary.libraryId}
                  className="federal-and-states-table-content"
                >
                  <div className="federal-and-states-table-title">
                    {stateLibrary.name.toUpperCase()} GAZETTE
                  </div>
                  <div className="federal-and-stated-table-line"></div>
                  <div className="federal-and-states-list">
                    {stateLibrary.library
                      .filter((library) => library.orderId !== null)
                      .map((library, idx) => (
                        <div
                          key={library.libraryId}
                          className="federal-and-states-list-item"
                          onClick={() => handleNavigation(library.libraryId)}
                        >
                          {library.displayName}
                        </div>
                      ))}
                  </div>
                </td>
              </>
            ))}
          </tr>
        ))}
      </>
    );
  };

  const replaceSpacesWithNbsp = (text) => {
    if (!text || typeof text !== "string") {
      return text; // Return as-is if text is not a string or is null/undefined
    }
    return text.replace(/ /g, "\u00A0");
  };

  useEffect(() => {
    const fetchLibraries = async () => {
      try {
        const response = await api.get(
          "/api/egazette-documents/libraries/all",
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        const filteredResponse = response.data.filter(
          (item) => item.orderID !== null
        );
        setLibraries(filteredResponse);
      } catch (error) {}
    };
    fetchLibraries();
  }, []);

  const handleSearch = (searchQuery, limit = 10, search) => {
    let payload = null;
    if (search === "semantic" || search === "keyword") {
      payload = {
        query: searchQuery,
        type: "content",
        modules: "egazette",
        search: search,
        limit,
        offset: 0,
      };
    } else {
      payload = {
        query: searchQuery,
        type: search,
        modules: "egazette",
        search: "keyword",
        limit,
        offset: 0,
      };
    }

    navigate("/e-gazette/search", { state: { payload } });
  };

  return (
    <div>
      <div className="federal-and-states-content">
        {/* <Search /> */}
        <div className="e-gazette-searchbox-container">
          <SearchBox
            onSearch={handleSearch}
            placeholder={"Enter keyword to search"}
            hasActNo={true}
            hasGazetteNo={true}
          />
        </div>
        <table className="federal-and-states-table">
          {renderFederal()}
          {(packageCode === 1 || packageCode === "1") && renderStates()}
        </table>
      </div>
    </div>
  );
}
